import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=0da4675d"
import script from "./change-password.ts?vue&type=script&lang=js&external"
export * from "./change-password.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports